import React, { createContext, useContext } from 'react'

import { useGlobalDataStore } from '@stores/globalData/globalData.store'
import { loadStripe } from '@stripe/stripe-js'

import type { Stripe } from '@stripe/stripe-js/types'

export type StripeContextType = {
  stripePromise: Promise<Stripe | null>
}

export const StripeContext = createContext({} as StripeContextType)

export const StripeProvider: React.FC = ({ children }) => {
  const stripePublicKey = useGlobalDataStore((s) => s.globalData.stripePublicKey)

  const stripePromise = loadStripe(stripePublicKey)
  const contextValue = { stripePromise }
  return <StripeContext.Provider value={contextValue}>{children}</StripeContext.Provider>
}

export default StripeProvider
export const useStripeContext = (): StripeContextType => useContext(StripeContext)
